import type { ReinstatementPaymentResult } from '../api/claims';

/** Staff-facing note for a reinstatement that changed the payment. */
export const reinstatementPaymentMessage = (result?: ReinstatementPaymentResult): string => {
  if (!result) return '';
  const amount = `£${Number(result.remainingAmount || 0).toFixed(2)}`;
  if (result.paymentAction === 'continued' && result.replacementIsManual) {
    return ` A new manual payment link for ${amount} was created for the remaining closed claims.`
      + ' The client has NOT been emailed - please send them this link:'
      + ` ${result.replacementPaymentUrl || '(link unavailable - check the payment record)'}`;
  }
  if (result.paymentAction === 'continued') {
    return ` A replacement payment for ${amount} was created for the remaining closed claims.`;
  }
  if (result.paymentAction === 'waived_remaining') {
    return ' The payment for the remaining closed claims was waived.';
  }
  return '';
};
